import { jsx as _jsx } from "react/jsx-runtime";
import { Drawer as MuiDrawer } from '@mui/material';
import React from 'react';
export const Drawer = React.forwardRef((props, ref) => {
    return _jsx(MuiDrawer, { ref: ref, variant: "persistent", ...props });
});
